import React from 'react';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import {
  Dialog,
  DialogActions,
  DialogActionsProps,
  DialogContent,
  DialogProps,
  DialogTitle,
  DialogTitleProps,
  IconButton,
  SxProps,
} from '@mui/material';

import { FormProvider } from './hook-form';
import { IconX } from 'src/libraries/icons';
import { StackColumn } from './stack-column';

//
//

export type AppDialogProps<T extends FieldValues = FieldValues> = DialogProps & {
  title?: React.ReactNode;
  titleProps?: DialogTitleProps;
  actions?: React.ReactNode;
  actionsProps?: DialogActionsProps;
  onClose?: () => void;
  children: React.ReactNode;
  form?: UseFormReturn<T>;
  formOnSubmit?: (e?: React.BaseSyntheticEvent) => void;
  sx?: SxProps;
};

export const AppDialog = <T extends FieldValues = FieldValues>({
  title,
  children,
  actions,
  titleProps,
  actionsProps,
  form,
  formOnSubmit,
  sx,
  ...props
}: AppDialogProps<T>) => {
  const content = (
    <StackColumn>
      <DialogContent sx={{ p: 0, pt: 1 }}>{children}</DialogContent>
      {actions ? (
        <DialogActions sx={{ p: '0px !important' }} {...actionsProps}>
          {actions}
        </DialogActions>
      ) : null}
    </StackColumn>
  );

  //

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      sx={{ '.MuiDialogTitle-root+.MuiDialogContent-root': { p: 0, paddingTop: 3 } }}
      slotProps={{ paper: { sx: { overflow: 'none', ...sx } } }}
      {...props}
    >
      <StackColumn sx={{ p: 2 }}>
      <DialogTitle
        variant="title2"
        textAlign="center"
        sx={{ fontWeight: 100, py: 0, px: 2 }}
        {...titleProps}
      >
        {title}

        {props?.onClose && (
          <IconButton
            aria-label="close"
            onClick={props?.onClose}
            sx={{ position: 'absolute', right: 8, top: 12, color: 'inherit' }}
          >
            <IconX />
          </IconButton>
        )}
      </DialogTitle>

      {form ? (
        <FormProvider methods={form} onSubmit={formOnSubmit}>
          {content}
        </FormProvider>
      ) : (
        content
      )}
      </StackColumn>
    </Dialog>
  );
};
